import { createQueryString, isUnauthorised } from '../../utils'
import { useCallback } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { captureException } from '@sentry/nextjs'

/*
We already redirect server-side on unauthorized requests, but we also want to redirect client-side as a fallback.
 */
export const useRedirectOnUnauthorized = (LOGIN_PATH: string) => {
  const path = usePathname()
  const query = useSearchParams()

  const redirectOnUnauthorized = useCallback(
    (error: Error): boolean => {
      if (typeof window === 'undefined') {
        const clonedError = structuredClone(error)
        clonedError.message = `Client-side redirectOnUnauthorized hook called server-side with error: ${error.message}`
        captureException(clonedError)
        return false
      }

      if (isUnauthorised(error)) {
        const currentUrl = `${path}${query.toString() ? `?${query.toString()}` : ''}`
        const loginQuery = createQueryString(undefined, [
          { name: 'error', value: error.message },
          { name: 'redirect', value: currentUrl },
        ])

        const redirectUrl = `${LOGIN_PATH}?${loginQuery}`
        // eslint-disable-next-line react-compiler/react-compiler
        window.location.href = redirectUrl

        return true
      }

      return false
    },
    [path, query, LOGIN_PATH]
  )

  return {
    redirectOnUnauthorized,
  }
}
